import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-755c8971"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "describe-text" }
const _hoisted_2 = { class: "describe-text" }
const _hoisted_3 = { class: "tips-row" }
const _hoisted_4 = { class: "process-edit-wrap" }
const _hoisted_5 = { class: "process-edit-tips" }
const _hoisted_6 = { class: "process-edit-head" }
const _hoisted_7 = { class: "process-tips" }
const _hoisted_8 = { class: "process-tips-header" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = { class: "info-header" }
const _hoisted_11 = { class: "info-row" }
const _hoisted_12 = { class: "info-row" }
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = { class: "info-header" }
const _hoisted_15 = { class: "info-row" }
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = { class: "info-row" }
const _hoisted_18 = { style: {"margin-top":"-2px"} }
const _hoisted_19 = { class: "cm-ui-mt10 cm-ui-ml10" }
const _hoisted_20 = { class: "cm-ui-mt10 cm-ui-mb10 cm-ui-ml10" }
const _hoisted_21 = { class: "watermark-attribute-wrap" }
const _hoisted_22 = { class: "watermark-attribute-setting" }
const _hoisted_23 = { style: {"line-height":"28px"} }
const _hoisted_24 = { class: "opacity-setting-row" }
const _hoisted_25 = { class: "watermark-attribute-preview" }
const _hoisted_26 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_SoftwareSelect = _resolveComponent("SoftwareSelect")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_ProcessEdit = _resolveComponent("ProcessEdit")!
  const _component_PolicyBindScope = _resolveComponent("PolicyBindScope")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_WatermarkPreview = _resolveComponent("WatermarkPreview")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "screen-watermark-edit-wrap important" }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _ctx.cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('screenWatermark.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          disabled: _ctx.isReadonly,
          class: "cm-ui-ml10",
          size: "small",
          type: "primary",
          onClick: _ctx.saveSetting
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('screenWatermark.save')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "formNode",
        class: _normalizeClass(["main-form", { readonly: _ctx.isReadonly }]),
        rules: _ctx.formRules,
        model: _ctx.strategyData,
        "label-position": "left",
        "hide-required-asterisk": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('screenWatermark.policyName'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                size: "small",
                style: {"width":"240px"},
                placeholder: _ctx.$t('screenWatermark.policyNamePlaceholder'),
                modelValue: _ctx.strategyData.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.strategyData.name) = $event)),
                modelModifiers: { trim: true },
                disabled: !_ctx.strategyData.strategy.main_switch,
                maxlength: "10"
              }, null, 8, ["placeholder", "modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            class: "label-line",
            prop: "watermark_mode",
            label: _ctx.$t('screenWatermark.watermarkMode')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                class: "sub-row",
                modelValue: _ctx.strategyData.strategy.type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.strategyData.strategy.type) = $event)),
                modelModifiers: { number: true },
                label: _ctx.WatermarkMode.global
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('screenWatermark.modeGlobal')), 1),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('screenWatermark.globalModeDesc')), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"]),
              _createVNode(_component_el_radio, {
                class: "sub-row",
                modelValue: _ctx.strategyData.strategy.type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.strategyData.strategy.type) = $event)),
                modelModifiers: { number: true },
                label: _ctx.WatermarkMode.software
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('screenWatermark.modeSoftware')), 1),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('screenWatermark.softwareModeDesc')), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "label"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.strategyData.strategy.type === _ctx.WatermarkMode.software)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                class: "target-software-item",
                label: _ctx.$t('screenWatermark.targetSoftware'),
                prop: "strategy.software_process"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SoftwareSelect, {
                    placement: "bottom",
                    "business-scene": 2,
                    disabled: !_ctx.strategyData.strategy.main_switch,
                    "model-value": _ctx.strategyData.strategy.software_process,
                    placeholder: _ctx.$t('screenWatermark.selectTargetSoft'),
                    onUpdate: _ctx.handleUpdateSoftwareSelect
                  }, null, 8, ["disabled", "model-value", "placeholder", "onUpdate"]),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('screenWatermark.selectedCount', { n: _ctx.strategyData.strategy.software_process.length })), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('screenWatermark.addTargetProcessTip')), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["cm-link-light process-button", { 'is-process-show': _ctx.isProcessShow }]),
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleProcessShow && _ctx.toggleProcessShow(...args)))
                      }, _toDisplayString(_ctx.$t('screenWatermark.addTargetProcess')), 3)
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('screenWatermark.controlTargetProcess')), 1),
                        _createTextVNode("  "),
                        _createVNode(_component_el_tooltip, {
                          placement: "bottom-start",
                          effect: "light"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('screenWatermark.wildcardRuleTitle')), 1),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('screenWatermark.wildcardBlock1Title')), 1),
                                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('screenWatermark.wildcardStarDesc')), 1),
                                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('screenWatermark.wildcardQuestionDesc')), 1)
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('screenWatermark.wildcardBlock2Title')), 1),
                                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('screenWatermark.wildcardStarDesc')), 1),
                                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('screenWatermark.wildcardQuestionDesc')), 1),
                                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('screenWatermark.wildcardDoubleStarDesc')), 1)
                              ])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("i", null, [
                              _createVNode(_component_CmSvgIcon, {
                                name: "assets/icons/info-gray",
                                monochrome: ""
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_ProcessEdit, {
                        modelValue: _ctx.strategyData.strategy.process_infos,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.strategyData.strategy.process_infos) = $event)),
                        cols: ['name', 'path'],
                        style: {"width":"785px"}
                      }, null, 8, ["modelValue"])
                    ], 512), [
                      [_vShow, _ctx.isProcessShow]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            class: "label-line",
            prop: "strategy_group_ids"
          }, {
            label: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('policyBindScope.applyMode')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_PolicyBindScope, {
                  "bind-mode": _ctx.strategyData.bind_mode ?? 0,
                  "group-ids": (_ctx.strategyData.strategy_group_ids || []) as string[],
                  "device-ids": _ctx.strategyData.device_ids || [],
                  "preset-group-id": _ctx.policyId ? undefined : (_ctx.fromGroupId != null && _ctx.fromGroupId !== '' ? Number(_ctx.fromGroupId) : undefined),
                  "permission-key": _ctx.PermissionFe.watermark_screen,
                  "strategy-over": _ctx.groupEditStrategyOver,
                  disabled: !_ctx.strategyData.strategy.main_switch,
                  "onUpdate:bindMode": _cache[5] || (_cache[5] = ($event: any) => (_ctx.strategyData.bind_mode = $event)),
                  "onUpdate:groupIds": _cache[6] || (_cache[6] = ($event: any) => (_ctx.strategyData.strategy_group_ids = $event as string[])),
                  "onUpdate:deviceIds": _cache[7] || (_cache[7] = ($event: any) => (_ctx.strategyData.device_ids = $event)),
                  onGroupUpdate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formNode.validateField('strategy_group_ids')))
                }, {
                  "group-tip": _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('screenWatermark.policyGroupTipTitle')), 1),
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('screenWatermark.policyGroupTip')), 1)
                  ]),
                  _: 1
                }, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over", "disabled"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "label-line",
            label: _ctx.$t('screenWatermark.watermarkAttr')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('screenWatermark.watermarkDisplay'),
                    prop: "strategy.wmdata.fields"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.watermarkFieldOptions, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            key: item.value,
                            disabled: _ctx.wmdata.fields.length >= 3 && !_ctx.wmdata.fields.includes(String(item.value)),
                            "model-value": _ctx.wmdata.fields.includes(String(item.value)),
                            onChange: ($event: any) => (_ctx.changeField($event, String(item.value)))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item.label), 1),
                              (item.value === _ctx.WatermarkField.custom_text)
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 0,
                                    disabled: !_ctx.wmdata.fields.includes(_ctx.WatermarkField.custom_text),
                                    modelValue: _ctx.wmdata.custom_text,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.wmdata.custom_text) = $event)),
                                    modelModifiers: { trim: true },
                                    maxlength: 15,
                                    size: "mini",
                                    style: {"width":"220px","margin-left":"5px"}
                                  }, null, 8, ["disabled", "modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "model-value", "onChange"]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    class: "label-line",
                    label: _ctx.$t('screenWatermark.watermarkDensity')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.watermarkDensityOptions, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_radio, {
                          key: index,
                          label: +item.value,
                          modelValue: _ctx.wmdata.density,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.wmdata.density) = $event)),
                          modelModifiers: { number: true }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "modelValue"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('screenWatermark.watermarkTilt'),
                    prop: "strategy.wmdata.rotate_angle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        size: "small",
                        modelValue: _ctx.wmdata.rotate_angle,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.wmdata.rotate_angle) = $event)),
                        "controls-position": "right",
                        min: 0,
                        max: 90
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    class: "label-line",
                    label: _ctx.$t('screenWatermark.watermarkType')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changeWatermarkType(_ctx.wmdata.mark_type)))
                      }, [
                        _createVNode(_component_el_radio, {
                          class: "sub-row",
                          modelValue: _ctx.wmdata.mark_type,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.wmdata.mark_type) = $event)),
                          modelModifiers: { number: true },
                          label: _ctx.WatermarkType.hidden
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('screenWatermark.markTypeHidden')) + _toDisplayString(_ctx.$t('screenWatermark.hiddenOpacity')) + " ", 1),
                            _createElementVNode("a", {
                              class: "cm-link-light",
                              href: "/help/watermark-decryption",
                              target: "_blank",
                              onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                            }, _toDisplayString(_ctx.$t('screenWatermark.viewHiddenTutorialShort')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label"]),
                        _createVNode(_component_el_radio, {
                          class: "sub-row",
                          modelValue: _ctx.wmdata.mark_type,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.wmdata.mark_type) = $event)),
                          modelModifiers: { number: true },
                          label: _ctx.WatermarkType.visible
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('screenWatermark.markTypeVisible')) + _toDisplayString(_ctx.$t('screenWatermark.visibleOpacity')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label"]),
                        _createVNode(_component_el_radio, {
                          class: "sub-row",
                          modelValue: _ctx.wmdata.mark_type,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.wmdata.mark_type) = $event)),
                          modelModifiers: { number: true },
                          label: _ctx.WatermarkType.custom
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('screenWatermark.markTypeCustom')) + _toDisplayString(_ctx.$t('screenWatermark.customOpacity')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label"])
                      ], 32),
                      _withDirectives(_createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_el_slider, {
                          modelValue: _ctx.wmdata.opacity,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.wmdata.opacity) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.wmdata.opacity,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.wmdata.opacity) = $event)),
                          min: _ctx.wmdata.mark_type === _ctx.WatermarkType.custom ? 5 : 0,
                          max: 100,
                          size: "mini",
                          "controls-position": "right",
                          style: {"width":"120px"}
                        }, null, 8, ["modelValue", "min"])
                      ], 512), [
                        [_vShow, _ctx.wmdata.mark_type === _ctx.WatermarkType.custom]
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_WatermarkPreview, { wmdata: _ctx.wmdata }, null, 8, ["wmdata"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["rules", "model", "class"])
    ]),
    _: 1
  })), [
    [_directive_loading, _ctx.isLoading]
  ])
}